import { isEmpty } from 'lodash';
import { Line } from 'components/common/types/Deal.types';

const lineHasPlannerOnlyFilters = (line: Line): boolean =>
  !isEmpty(line.segment?.selectedSegments) ||
  !!line.indexOptimisation?.length ||
  !!line.proximity?.plannerPoi?.length ||
  !!line.proximity?.openStreetMapPoi?.length;

export const hasPlannerOnlyFilters = (lines: Line[], currentLine: Line): boolean => {
  const linesToCheck = lines.some((line) => line.id === currentLine.id) ? lines : lines.concat(currentLine);

  return linesToCheck.some((line) => lineHasPlannerOnlyFilters(line.id === currentLine.id ? currentLine : line));
};
